import { IActivityHistoryCommonFilterGroup, IActivityHistoryCustomFilterGroup } from "../../filter";
import { IActivityHistoryItem } from "../model";
import { FalseSpec } from "./false-spec";
import { PropPathSpec } from "./prop-path-spec";
import { Spec } from "./spec";

export class CustomFilterSpec extends Spec<IActivityHistoryItem> {
  constructor(private filters: IActivityHistoryCustomFilterGroup[]) {
    super();
  }

  isSatisfiedBy(item: IActivityHistoryItem): boolean {
    const enabledGroups = this.filters.filter((group) => group.enabled);

    if (enabledGroups.length === 0) {
      return true; // No hay filtros activados, se aceptan todos los items
    }

    return enabledGroups.every((group) => {
      if (!this.belongsToGroup(item, group)) {
        return true;
      }

      const enabledFilters = group.filters.filter(
        (filter) => filter.enabled || filter.singleOption,
      );

      if (enabledFilters.length === 0) {
        return true;
      }

      return enabledFilters.every((filter) => {
        if (filter.singleOption) {
          // Si el filtro booleano está DESACTIVADO, debe filtrar los elementos con ese valor
          return !filter.enabled
            ? new PropPathSpec(filter.propPathValue, false).isSatisfiedBy(item)
            : true; // Si está activado, no filtra nada
        }

        if (!filter.enabledValues || filter.enabledValues.length === 0) {
          return true;
        }

        const propSpec = filter.enabledValues.reduce((acc, value) => {
          return acc.or(new PropPathSpec(filter.propPathValue, value));
        }, new FalseSpec());

        return propSpec.isSatisfiedBy(item);
      });
    });
  }

  private belongsToGroup(
    item: IActivityHistoryItem,
    group: IActivityHistoryCustomFilterGroup,
  ): boolean {
    return item.type === group.id;
  }
}
